"use strict";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const initSlider = document.querySelector(".o-diferenciais__slider");
        if (!initSlider) return;

        const swiper = new Swiper(".o-diferenciais__slider", {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,

            navigation: {
                nextEl: ".o-diferenciais__arrow--next",
                prevEl: ".o-diferenciais__arrow--prev",
            },
        });
    });
}
